import React, { useMemo } from 'react'
import { Route, Switch } from 'react-router-dom'

import NotFound from '../containers/NotFound'

import { useEducationFeatures } from 'education-tools'
import getPages from '../pages'

const App = () => {
  const features = useEducationFeatures()
  const isLoadingFeatures = features === null

  const pages = useMemo(() => getPages(), [])

  return (
    <Switch>
      {pages}
      {!isLoadingFeatures && <Route path='*' component={NotFound} />}
    </Switch>
  )
}

export default App
